import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Link } from "react-router-dom";
import { Medal } from "@phosphor-icons/react";

export default function TopBadgeCollectors({ days = 7 }) {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get(`/badges/top?days=${days}&limit=3`).then(({ data }) => setData(data)).catch(() => {});
    }, [days]);

    if (!data) return null;
    if (data.leaders.length === 0) {
        return (
            <div className="mt-8" data-testid="top-badges-widget-empty">
                <div className="px-3 text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2 flex items-center gap-1.5">
                    <Medal size={11} weight="duotone" className="text-amber-400" />
                    top badges · {days}d
                </div>
                <div className="px-3 py-2 text-[10px] font-mono text-slate-600 leading-relaxed">
                    // no badges minted this week.<br/>
                    // be the first to earn one.
                </div>
            </div>
        );
    }

    return (
        <div className="mt-8" data-testid="top-badges-widget">
            <div className="px-3 text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-2 flex items-center gap-1.5">
                <Medal size={11} weight="duotone" className="text-amber-400" />
                top badges · {days}d
            </div>
            <div className="space-y-1 px-2">
                {data.leaders.map((u, i) => (
                    <Link
                        key={u.user_id}
                        to={`/u/${u.username}`}
                        className="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-800/40 rounded-sm transition-colors group"
                        data-testid={`badge-leader-${u.username}`}
                    >
                        <span className={`text-sm font-bold w-4 text-right ${i === 0 ? "text-amber-400" : i === 1 ? "text-slate-300" : "text-orange-400"}`}>
                            {i + 1}
                        </span>
                        {u.picture ? (
                            <img loading="lazy" decoding="async" src={u.picture.startsWith("http") ? u.picture : `/api${u.picture.replace(/^\/api/, "")}`} alt="" className="w-5 h-5 rounded-sm border border-white/10" />
                        ) : (
                            <div className="w-5 h-5 rounded-sm bg-slate-800 border border-slate-700 flex items-center justify-center text-[10px] font-bold text-cyan-400">
                                {u.username[0].toUpperCase()}
                            </div>
                        )}
                        <div className="flex-1 min-w-0">
                            <div className="text-xs font-mono text-slate-200 group-hover:text-cyan-400 truncate">@{u.username}</div>
                        </div>
                        <span className="text-[10px] uppercase tracking-widest text-amber-300 font-bold flex items-center gap-0.5">
                            +{u.badges_won_window} <Medal size={9} weight="fill" />
                        </span>
                    </Link>
                ))}
            </div>
        </div>
    );
}
